import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { UserAC } from '@/types';
import { BehaviorSubject } from 'rxjs';

interface IGetUserACDataTableStructureProps {
  isInspectMode: () => boolean;
  onAcPiloteChange: (row: any, checked: boolean) => void;
  userAcs: BehaviorSubject<UserAC[]>;
  rowActions?: DataTableRowActions;
}

export const getUserACDataTableStructure = ({
  isInspectMode,
  onAcPiloteChange,
  userAcs,
  rowActions,
}: IGetUserACDataTableStructureProps): DynamicDataTable => {
  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.userInfo.table.nom',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };

  const ancrageColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.userInfo.table.ancrage',
    accessorKey: 'ancrage',
    variant: DataTableColumnVariant.TEXT,
  };
  const contactColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.userInfo.table.contact',
    accessorKey: 'contact',
    variant: DataTableColumnVariant.TEXT,
  };

  const acPricipaleColumn: DynamicDataTableColumn<any> = isInspectMode()
    ? {
        label: 'AC Principale',
        accessorKey: 'acPilote',
        variant: DataTableColumnVariant.BADGE,
        renderAs: (value: any) => ({ value: value ? 'Oui' : 'Non' }),
        props: {
          innerClass: 'px-3 py-1',
          getSeverity: (value: boolean) => (value === true ? 'success' : 'danger'),
        },
      }
    : {
        label: 'AC Principale',
        accessorKey: 'acPilote',
        variant: DataTableColumnVariant.SWITCH,
        renderAs: (value: any) => {
          return {
            value: value,
            class: '',
          };
        },
        props: {
          onChange: (checked: boolean, value: any) => {
            const row = userAcs.value.find(ac => ac.acPilote === value);
            if (row) {
              onAcPiloteChange(row, checked);
            }
          },
          disabled: isInspectMode(),
        },
      };

  return {
    singular: 'settings.userInfo.table.ac',
    plural: 'settings.userInfo.table.acs',
    columns: [nameColumn, ancrageColumn, contactColumn, acPricipaleColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10],
    stripedRows: true,
    searchableFields: ['nom', 'ancrage', 'contact'],
    rowActions,
  };
};
